<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="150" :loading="loading" class="light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table id="exportContactUs" :mobile-breakpoint="0" :headers="headers" :items="contactUsList" hide-default-footer class="elevation-1">
        <template v-slot:item.firstName="{ item }"> {{ item.firstName }} {{ item.lastName }} </template>
        <template v-slot:item.phone="{ item }">
          {{ item.phone }}
        </template>
        <template v-slot:item.email="{ item }">
          {{ item.email }}
        </template>

        <template v-slot:item.message="{ item }">
          {{ item.message }}
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
export default {
  props: {
    contactUsList: {
      required: true,
    },
    headers: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      options: {
        itemsPerPage: 25,
        page: 1,
      },
    };
  },
  created() {},

  methods: {
    exportExcel() {
      this.loading = true;
      Utils.htmlToExcel("exportContactUs", "ContactUs", false);

      this.loading = false;
    },
  },
};
</script>
